module.exports = __webpack_public_path__ + "static/media/bigwar-1.a49a308b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bigwar-1.png
// module id = 97
// module chunks = 0